import React, { useState, useContext, useEffect, useRef }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonText, IonModal  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { helpCircleOutline } from 'ionicons/icons';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { App_Header } from '../components/App_Header_Retail';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';
import { OverviewBusinessSlides } from '../components/Tab_Overview';
import { Tab_Operations } from '../components/Tab_Operations';
//import { CleaningServicesSlides } from '../components/Tab_CleaningServices';
//import { ReservationSlides } from '../components/Tab_Reservations';
import {Retail_Management} from '../components/retail_management_services';

import { Helpdesk_Public } from '../../../zInternal_Features/merchant/components/Modal_HelpChat_Public';
import { Modal_UpdateCompanyInfo } from '../../../zInternal_Features/merchant/components/Modal_UpdateCompanyInfo';

import { useHistory} from "react-router-dom";


 export function Retail_MerchantHomePage () {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [overviewData, setOverviewData] = useState(false);
    let [operationsSlideData, setOperationsSlideData] = useState(true);
    // let [cleaningServicesData, setCleaningServicesData] = useState(false);
    // let [reservationsData, setReservationsData] = useState(false);
    // let [restaurantData, setRestaurantData] = useState(false);

    let [color_overview, setColor_overview] = useState('clear')
    let [color_operations, setColor_operations] = useState('outline')
    // let [color_cleaningServices, setColor_cleaningServices] = useState('clear')
    // let [color_reservations, setColor_reservations] = useState('clear')
    // let [color_restaurant, setColor_restaurant] = useState('clear')

    let [managementService_retail, setManagementService_retail] = useState(false);
    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    let [viewMerchantList_info, setViewMerchantList_info] = useState([]);
    let [companyInfoModal, setCompanyInfoModal] = useState(false);
    let [onboardingStatus, setOnboardingStatus] = useState('');

    const isInvalid = (v) => ['', 'null', 'NULL', 'undefined'].includes(v);

    let history = useHistory();
    let router = useIonRouter();

    const setupIntervalRef = useRef(null);

    useEffect(() => {
        

        setViewMerchantList_info([]);


            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    },
                body: JSON.stringify({
                    Tracker: "00_retrieve_company_info",
                    user: acctID,
                    sessionID: sessionID,

                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'ghanaverified/', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                    let cols_spit = rows[rowNum].split('#');
                    let cols = cols_spit[0].split('|');
                    let cols_1 = cols_spit[1].split('|');


                    setViewMerchantList_info((prevViewMerchantList_proServices) => {
                        return prevViewMerchantList_proServices.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                            mtnCompanyPhoneNumber: cols[13],
                            merchantID: cols_1[0], 
                            merchantName: cols_1[1],
                            merchantMomoNumber: cols_1[2],
                            merchantUpload_ghanaID: cols_1[3],
                            merchantUpload_businessRegistrationID: cols_1[4],
                            merchantAddress: cols_1[5],
                            latitude: cols_1[6],
                            longitude: cols_1[7],
                            merchantUpload_companyMainImage: cols_1[8],
                            companyShowcase: cols_1[9],
                            date_logged: cols_1[10],
                            onboardingStatus: cols_1[11],
                        })

                    });

                        if( isInvalid(cols[1]) ||
                        isInvalid(cols[2]) ||
                        isInvalid(cols[3]) ||
                        isInvalid(cols[4]) ||
                        isInvalid(cols[5]) ||
                        isInvalid(cols[6]) ||
                        isInvalid(cols[13])) 
                        {
                            setCompanyInfoModal(true);
                        }
                    
                        setOnboardingStatus(cols_1[11]);
                }

                //props.confirmComplete();
            })
    }, []);


    function overviewHandler()
    {
        setOverviewData(true);
        setOperationsSlideData(false);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(false);

        setColor_overview('outline');
        setColor_operations('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');


    }
    function checkInCheckOutHandler()
    {
        setOverviewData(false);
        setOperationsSlideData(true);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(false);

        setColor_overview('clear');
        setColor_operations('outline');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');

    }
    function cleaningServicesHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(true);
        // setReservationsData(false);
        // setRestaurantData(false);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('outline');
        // setColor_reservations('clear');
        // setColor_restaurant('clear');

    }
    function reservationsHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(false);
        // setReservationsData(true);
        // setRestaurantData(false);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('outline');
        // setColor_restaurant('clear');

    }

    function restaurantHandler()
    {
        // setOverviewData(false);
        // setCheckInCheckOutData(false);
        // setCleaningServicesData(false);
        // setReservationsData(false);
        // setRestaurantData(true);

        // setColor_overview('clear');
        // setColor_checkInCheckOut('clear');
        // setColor_cleaningServices('clear');
        // setColor_reservations('clear');
        // setColor_restaurant('outline');

    }


    const handleHomepage_zasava = () => {


        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
            //history.push("https://zasava.com");

        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
           // history.push("https://zasavatest.com");
        }
  };

  function handleHomepage(event) {

    // alert(event);
    // alert(window.location.pathname)

        // history.push(event);
        router.push(event, 'forward', 'replace');
        //window.location = event;
    };


    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }
    


function notifyAccount_setup()
{                              
                                
                                        const requestOptions = {
                                            method: 'POST',
                                            //credentials: 'include',
                                            headers: {
                                                'Accept': 'text/html, application/json',
                                                'content-type': 'application/json',
                                                //'cookie': 'cookie',
                                            },
                                            body: JSON.stringify({
                                                Tracker: 'complete_setup_admin_notify',
                                                user: acctID,
                                                fmc_schema: schema,
                                                xOnboardingStatus: onboardingStatus,
                                                sessionID: sessionID,
                                                
                                            }),
                                        }

                                        fetch(baseURL+'/initial_setup_notify', requestOptions)
                                        .then(res => res.text())
                                        .then(data => {
                                                

                                        alert(data);

                                
                                        })
        
}

  useEffect(() => {

    // alert("in Home checking initialSetup 1");
    // alert(acctID);
    // alert(authMerchant_objects.initialSetup?.details?.step_1);
    // alert(authMerchant_objects.initialSetup?.details?.step_2);
    // alert(authMerchant_objects.accessRights[0]);

    if(acctID != null && authMerchant_objects.accessRights[0] == 'admin' && (authMerchant_objects.initialSetup?.details?.step_1 == false || authMerchant_objects.initialSetup?.details?.step_2 == false))
    {

            //alert("in Home checking initialSetup 2");
            //alert(onboardingStatus);

            if(onboardingStatus == 'INACTIVE')
            {
                //alert("ONBOARDING STATUS IS INACTIVE");

                notifyAccount_setup();
            }
            else if(onboardingStatus == 'NOTIFYING' )
            {
                //alert("ONBOARDING STATUS IS NOTIFYING");
                return;
            }

    }
     else {
        // Setup complete → clear interval
        if (setupIntervalRef.current) {
            clearInterval(setupIntervalRef.current);
        }
    }

  },[acctID, authMerchant_objects.initialSetup, authMerchant_objects.accessRights[0], onboardingStatus])
    // alert('In Retail_MerchantHomePage');   
    // // alert(acctID);
    // // alert(employeeID);
    // // //alert(schema);
    // // //alert(access);
    // alert(authMerchant_objects.selectedTutorial?.tutorial_id);
    // alert(authMerchant_objects.selectedTutorial?.details);
    // alert(authMerchant_objects.selectedTutorial?.details.step_1);
    // alert(authMerchant_objects.selectedTutorial?.details.step_2);
    // alert(authMerchant_objects.selectedTutorial?.details.step_3);
    // alert(authMerchant_objects.selectedTutorial?.details.step_4);


    return (
            <React.Fragment>
                {companyInfoModal == true && authMerchant_objects.accessRights[0] == 'admin' ? (
                        
                        <Modal_UpdateCompanyInfo openModal={ companyInfoModal } closeModal={() => setCompanyInfoModal(false)}></Modal_UpdateCompanyInfo>
                ) : (
                <>
                <IonHeader>
                <IonToolbar className="grid_header_componentSlides" color="dark">
                <IonGrid className='grid_header'>
                    {authMerchant_objects.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='4'>
                            <IonTitle >{authMerchant_objects.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='6'>
                            <IonTitle >{authMerchant_objects.employeeFirstName + ' ' + authMerchant_objects.employeeLastName}</IonTitle>
                        </IonCol>
                        {authMerchant_objects.initialSetup?.details?.step_1 == false && <IonCol className='gh_top_links_col_right' size='2'>
                            <IonButtons>
                            <IonMenuButton className='flash-tutorial'></IonMenuButton>
                            </IonButtons>                        
                            </IonCol>}
                        {authMerchant_objects.initialSetup?.details?.step_1 == true && <IonCol className='gh_top_links_col_right' size='2'>
                            <IonButtons>
                            <IonMenuButton c></IonMenuButton>
                            </IonButtons>
                            </IonCol>}
                    </IonRow>}
                    </IonGrid>
                    </IonToolbar>
                    <IonToolbar className="grid_header_componentSlides" color="dark">
                    <IonGrid>
                    <IonRow>
                        <IonCol size = '6'>
                            <IonButton className= 'medium-button-tabs' fill={color_overview} onClick={() => overviewHandler()}> Overview </IonButton>
                        </IonCol>
                        <IonCol size = '6'>
                            <IonButton className= 'medium-button-tabs' fill={color_operations} onClick={() => checkInCheckOutHandler()}> Orders </IonButton>
                        </IonCol>
                       {/*} <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_cleaningServices} onClick={() => cleaningServicesHandler()}> Orders </IonButton>
                        </IonCol>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_reservations} onClick={() => reservationsHandler()}> Reports </IonButton>
                        </IonCol>*/}
                    </IonRow>
                </IonGrid>
                </IonToolbar>
                </IonHeader>



                    {overviewData == true && <OverviewBusinessSlides openModal={ overviewData } closeModal={() => setOverviewData(false)}></OverviewBusinessSlides>}
                    {operationsSlideData == true && <Tab_Operations openModal={ operationsSlideData } closeModal={() => setOperationsSlideData(false)}></Tab_Operations>}   
                    {/*{cleaningServicesData == true && <CleaningServicesSlides openModal={ cleaningServicesData } closeModal={() => setCleaningServicesData(false)}></CleaningServicesSlides>}
                        reservationsData == true && <ReservationSlides openModal={ reservationsData } closeModal={() => setReservationsData(false)}></ReservationSlides>}    */}

                    {managementService_retail == true && <Retail_Management openModal={managementService_retail} closeModal={() => setManagementService_retail(false)}></Retail_Management>}

                    {viewHelpDeskModal == true && <Helpdesk_Public openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Public>}

                <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='2'>
                                    <IonButton fill="clear" size='medium' onClick={() => setViewHelpDeskModal(true)}>
                                            <IonText>HELP</IonText>
                                            <IonIcon icon={helpCircleOutline} />
                                        </IonButton>
                                </IonCol>
                                <IonCol size='8'>
                                    {(authMerchant_objects.accessRights[0] == 'admin' || authMerchant_objects.accessRights[0] == 'manager') && ( 
                                        (authMerchant_objects.initialSetup?.details?.step_1 == true && ( authMerchant_objects.initialSetup?.details?.step_2 == false || authMerchant_objects.initialSetup?.details?.step_3 == false || authMerchant_objects.initialSetup?.details?.step_4 == false ) ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "1" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "2" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "3" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "4" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "5" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "6" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "7" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "8" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "9" && authMerchant_objects.selectedTutorial?.details?.step_1 == false ) ||
                                        (authMerchant_objects.selectedTutorial?.tutorial_id == "10" && authMerchant_objects.selectedTutorial?.details?.step_1 == false )
                                        ) ?
                                            <IonButton  className='small_button_initialSetup' auto-hide='false' onClick={ () => setManagementService_retail(true)} >Management</IonButton> 
                                            :   <IonButton  className='small_button' auto-hide='false' onClick={ () => setManagementService_retail(true)} >Management</IonButton> }
                                </IonCol>
                                <IonCol size='2'>
                                    <IonButton className="custom-public-button" fill={'clear'} onClick={() => handleHomepage('/home')}>
                                            <IonText style={{fontSize: '.5em'}}>PUBLIC</IonText>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                           {/* {(authMerchant_objects.authenticated != null && (authMerchant_objects.acctID == "G1" || authMerchant_objects.acctID == "G27" || authMerchant_objects.acctID == "G23")) &&
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                    </IonCol>
                                 </IonRow>
                                } */}
                        </IonGrid>

                </IonFooter>
                </>
                )}
            </React.Fragment>

    );
};



export default Retail_MerchantHomePage;